import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import {
  AppBar as MuiAppbar,
  Box,
  IconButton,
  Link,
  Toolbar,
} from '@mui/material'

import { ReactComponent as MagnifyingGlass } from '../../../assets/icons/magnifying-glass.svg'
import { ReactComponent as SignOut } from '../../../assets/icons/sign-out.svg'
import Logo from '../../../assets/images/ctt-logo.svg'
import * as routes from '../../../routes'

import styles from './styles'

const AppBarMobile = ({ onLogout, onClickSearch }) => {
  return (
    <MuiAppbar position="fixed" sx={styles.appBar}>
      <Toolbar sx={styles.toolbar}>
        <Link
          underline="none"
          component={NavLink}
          to={routes.HOME.linkTo()}
          sx={styles.logoContainer}
        >
          <img src={Logo} alt="" />
        </Link>

        <Box>
          <IconButton
            size="large"
            sx={styles.magnifyingGlassButton}
            onClick={onClickSearch}
          >
            <MagnifyingGlass />
          </IconButton>
          <IconButton onClick={onLogout} size="large" sx={styles.signOutButton}>
            <SignOut />
          </IconButton>
        </Box>
      </Toolbar>
    </MuiAppbar>
  )
}

AppBarMobile.propTypes = {
  onLogout: PropTypes.func,
  onClickSearch: PropTypes.func,
}

export default AppBarMobile
